module.exports = __webpack_public_path__ + "static/media/FooterBrand.3ec5af47.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/FooterBrand.webp
// module id = 199
// module chunks = 15